import axios from 'axios';
import API_URL from '../utils/apiUrl';

export const submitForm = async (data) => {
  const response = await axios.post(`${API_URL}/forms/submit`, data);
  return response.data;
};

export const getFormSubmissions = async (params = {}) => {
  const response = await axios.get(`${API_URL}/forms`, { params });
  return response.data;
};

export const updateFormStatus = async (id, status) => {
  const response = await axios.patch(`${API_URL}/forms/${id}/status`, { status });
  return response.data.data;
};
